<template>
    <div>
        <div class="description" v-if="maxvideos != -1">For this category, a maximum of {{maxvideos}} videos is allowed.</div>

        <h5 class="h5-updated pull-right" v-if="!isadmin">Nominee Entry Status: <span :class="entryVideoStatus">{{entryVideoStatus}}</span></h5>

        <div class="video-component-wrapper">
            <div class="row fullwidth">
                <div class="left large-4 entrant-left video-filename-listing col-12 col-md-4">
                    <ul>
                        <li class="video-filename-item" :class="index == activeVideoIndex ? 'active' : ''" v-for="(video, index) in videofiles" @click="videoActive(index)" style="word-break: break-all;">
                            <div>{{index+1}} - {{video.pivot.episode_title}}</div>
                        </li>
                    </ul>
                </div>
                <div class="right large-8 omega entrant-right video-entry-right-form col-12 col-md-8">
                    <div v-for="(video, index) in videofiles">
                        <div class="vid-wrapper" v-if="index == activeVideoIndex">
                            <div class="filename-wrapper">
                                <h4 class="mb-0 pr-1 pull-left" style="line-height: 21px;">Video File: </h4>
                                <span id="vid_file_name" class="filename" v-text="video.filename"></span>
                                <span v-if="isadmin && video.audio_type == '5.1'" class="border-2-black ml-3">5.1</span>
                            </div>
                            <div class="file-info pl-0">
                                <h4 class="mb-0 pr-1 pull-left displaybloc mt-0">Video File Status:</h4>
                                <div class="display-inline " v-if="video.id && !isadmin" v-text="statusDisplay(video.status)"></div>
                            </div>
                            <div class="row fullwidth">
                                <div class="col-5" v-if="video.asset_id">
                                    <div class="video-placeholder">
                                        <video-file :vfoid="video.id" :asset_id="video.asset_id" :filename="video.filename" :is_admin="isadmin"></video-file>
                                    </div>
                                </div>
                                <div class="col-7">
                                    <div class="image-wrapper">
                                        <div class="button-wrapper" v-if="video.id">
                                            <a v-if="isadmin" :href="video.temporary_object_url" download class="btn btn-primary"><i class="fa fa-download"></i> Download</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="video-text-info-wrapper" v-if="video.id">
                                <div class="form-group-beside entry-field" v-if="requiredfields['showEpisodeField'] == 1">
                                    <label class="entry-field__label" for="episode">Episode Number <em class="yellow no-style">*</em></label>
                                    <div class="entry-field__value" id="episode" v-if="video.pivot.episode">{{ video.pivot.episode }}</div>
                                </div>
                                <div class="clear-both">
                                    <div class="form-group-beside entry-field">
                                        <label class="entry-field__label">Episode Title <em class="yellow no-style" v-if="requiredfields['episodeTitleFieldRequired'] == '1'">*</em></label>
                                        <div class="entry-field__value" id="episode_title">{{video.pivot.episode_title}}</div>
                                    </div>
                                    <div class="form-group-beside entry-field logline-video-upload">
                                        <label class="entry-field__label">Episode Description  <em class="yellow no-style" v-if="requiredfields['loglineFieldRequired'] == '1'">*</em></label>
                                        <div class="entry-field__value" id="log_line">{{video.pivot.logline}}</div>
                                    </div>
                                    <div class="form-group-beside entry-field" v-if="requiredfields['closedCaptionFieldRequired'] != 'No'">
                                        <label class="entry-field__label">Closed Captioning Upload <em class="yellow no-style" v-if="requiredfields['closedCaptionFieldRequired'] == 'Required'">*</em></label>
                                        <div class="entry-field__value" v-if="video.CCFileUrl"><span>{{video.CCFilename}}</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    // import dropzoneS3Single from './DropZoneS3Single.vue';
    import modal from './Modal.vue';
    import videoFile from './Videofile.vue';
    import Select2 from 'v-select2-component';
    import vueDropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import AWS from 'aws-sdk/global';
    import S3 from 'aws-sdk/clients/s3';
    export default {
        components: {modal, Select2, vueDropzone, videoFile},
        props: ['videoobject', 'maxvideos', 'entryid', 'userid', 'isadmin', 'nominee_video_status', 'catsettingsrequiredfields'],
        data() {
            return {
                episodeArray: Array.from({length: 30}, (_, index) => index + 1),
                entryVideoStatus: this.nominee_video_status,
                requiredfields: this.catsettingsrequiredfields,
                buttonDisabled: true,
                videofiles: this.setInitialVideoFile(),
                existingvideos: [],
                exisitingVideoSelected: '',
                activeVideoIndex: '',
                maxWords: 50,
                numberOver: '',
                showWordCountMax: false,
                videoObjectDetails: {
                    'id': '',
                    'filename': '',
                    'pivot': {
                        'weight':0,
                        'episode': '',
                        'episode_title': '',
                        'logline': '',
                    },
                },
                videoStatuses: ['Under Review', 'Need More Information', 'Video Approved', 'Uploading', 'Uploading Failed', 'Processing Failed'],
            }
        },
        created: function() {
            let app = this;
            if(!app.requiredfields.showEpisodeField) {
                app.requiredfields.showEpisodeField = '1';
            }
        },
        methods: {
            statusDisplay(inputStatus) {
                switch (inputStatus) {
                    case 'Upload Failed':
                        return 'Upload Failed';
                    case 'Uploading':
                        return 'Uploading...';
                    case 'Need More Info':
                        return 'Needs More Information';
                    case 'Canceled':
                        return 'Canceled';
                    case 'Video Approved':
                        return 'Video Approved';
                    case 'Processing Failed':
                        return 'Under Review';
                    default:
                        return 'Under Review';
                }
            },
            setInitialVideoFile: function() {
                let app = this;
                let videoF = [];
                    app.videoobject.forEach(function(videoitem,position) {
                       videoF[videoitem.pivot.weight] = videoitem;
                    });
                    if(videoF.length < app.maxvideos) {
                        var i;
                        for (i = videoF.length; i < app.maxvideos; i++) {
                            videoF.push({
                                'id': '',
                                'filename': '',
                                'pivot': {
                                    'episode': '',
                                    'episode_title': '',
                                    'logline': '',
                                    'weight': i
                                },
                            });
                        }
                    } else if ((app.maxvideos == -1) && (videoF.length == 0)) {
                        videoF.push({
                            'id': '',
                            'filename': '',
                            'pivot': {
                                'episode': '',
                                'episode_title': '',
                                'logline': '',
                                'weight': 0
                            },
                        });
                    }
                return videoF
            },
            videoActive: function(index) {
                let app = this;
                app.activeVideoIndex = index;
            },
        }
    }
</script>
